var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('q-img',{class:['teacher-icon',  _vm.type],attrs:{"src":_vm.teacherUrl,"width":_vm.size,"height":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }